import { AWARDS_TYPE_ENUM } from '@/modules/people/definitions/pay-rates';
import {
  StatePayDetail,
  StatePayDetailSalaryState,
} from '@/modules/people/store/employment/index';
import { AreaBasePayV2 } from '@/modules/people/types/employment';

export default function getPayDetailModel(
  override: { isPayRateAssigned?: boolean } = { isPayRateAssigned: false }
): StatePayDetail {
  return {
    active: true,
    isDefault: false,
    contract: AWARDS_TYPE_ENUM.HOURLY.Id,
    contractName: '',
    identifier: '',
    contractObject: undefined,
    payRateType: undefined,
    type: undefined,
    basePayRule: undefined,
    basePayRuleIsEditable: false,
    payRules: undefined,
    leaveRules: [],
    salaryDistributionConfig: undefined,
    payrollId: undefined,
    validationError: {},
    isPayRateAssigned: override.isPayRateAssigned || false,
    areaBasedPayV2: {
      areaSelected: [],
      areaIndexed: {},
      areaList: [],
      areaGroups: [],
      validationError: {},
    } as AreaBasePayV2,
    payRatesIndexedByEmploymentType: undefined,
    associatedTimesheetCount: undefined,
    thirdPartySync: '',
    agreementId: 0,
    locations: [],
    salaryState: {} as StatePayDetailSalaryState,
    contractLevels: [],
    level: '',
    isSensitiveData: false,
  };
}
